export const PRODUCT_CATEGORY_CODES = {
  PC001: 'productCategoryDoNotExist',
  PC002: 'productCategoryNameExist',
  PC003: 'productCategoryImageNotExist',
};
